import React, { Component } from 'react'

export default class login extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}
